import React from 'react';
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from "../navigation/NavigationActions";
import {connect} from "react-redux";
import {saveSurveyCount, getSurveyCount, hasSurveyCount} from "../utils/settingsStore";
import {getUserSync} from "../utils/auth";

class SurveyScreen extends React.PureComponent {


    constructor(props) {
        super(props);
        this.state = {
            copied: false,
        };
    }

    componentWillMount() {
        if(hasSurveyCount()){
            saveSurveyCount(getSurveyCount() + 1);
        }else{
            saveSurveyCount(0);
        }
    }

    getShareUrl() {
        return 'https://toplife.zone/live/connect/' + getUserSync()._id
    }

    render() {
        const {t} = this.props;

        return (
            <div >
                <div className="toolbar">
                    <div className="back-arrow" onClick={() => this.props.goBack()}>
                        <ArrowBack />
                    </div>

                    <h2 style={styles.flex}>{t('survey:title')}</h2>

                </div>
                <div style={styles.shareContainer}>
                    <iframe title="survey" src="https://docs.google.com/forms/d/e/1FAIpQLSdMQXCcdzHFh5O6-6ty_Y2NlUQqp9U23kgnxMWEiVc36iYjAA/viewform?embedded=true" width="100%" height="3000" frameborder="0" marginheight="0" marginwidth="0">Wird geladen...</iframe>
                </div>
            </div>
        );
    }

}


const styles = ({
    shareContainer: {
        maxWidth: 1200,
        margin: '0 auto',
        paddingTop: 72,
        paddingRight: 16,
        paddingLeft: 16
    },
    flex: {
        flex: 1,
    }
});

/*
 const mapStateToProps = (state) => {
 return {
 user: state.auth.user,
 loadingLevelFailed: state.loadingLevelFailed,
 isLoading: state.levelLoading
 };
 };*/

const mapDispatchToProps = (dispatch) => {
    return {
        goBack: () => dispatch(navigationBack())
    };
};

export default connect(null, mapDispatchToProps)(translate(['survey', 'common'])(SurveyScreen));


// WEBPACK FOOTER //
// ./src/survey/SurveyScreen.js